import {
    Box,
    FormControl,
    FormHelperText,
    Tooltip,
    Typography,
} from "@mui/material";
import StandartButton from "components/atoms/StandartButton";
import FormatIndentIncreaseIcon from "@mui/icons-material/FormatIndentIncrease";
import { Col, Form } from "react-bootstrap";
import { ButtonVariant } from "Constant/button";
import { beautifyJson } from "Constant/string";
const placeholder = `{
      "name": "John Doe",
      "email": "john@example.com",
      "roles": ["admin", "user"],
      "isActive": true,
      "address": "St. Joe street No: 15",
      "job": "Engineer",
    }`;
const Json = ({ error, isValidJson, textbox, setTextbox }) => {
    return (
        <Col md={12} xs={12}>
            <Form.Group className="mb-3">
                <FormControl
                    style={{ width: "100%", position: "relative" }}
                    error={error?.textbox}
                >
                    <div className="form-group mt-3">
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            className="mb-2"
                        >
                            Please enter a JSON:
                        </Typography>
                        <textarea
                            className={`form-control ${
                                (!isValidJson() && textbox) || error?.textbox
                                    ? "error"
                                    : ""
                            }`}
                            placeholder={placeholder}
                            rows={10}
                            onChange={(e) => setTextbox(e.target.value.trim())}
                            onBlur={(e) => {
                                const rawValue = e.target.value;
                                const beautified = beautifyJson(rawValue);
                                setTextbox(beautified);
                            }}
                            value={textbox}
                        />
                    </div>
                    {error?.textbox && (
                        <FormHelperText>This field is required</FormHelperText>
                    )}

                    <Box
                        style={{
                            position: "absolute",
                            bottom: "1.5rem",
                            right: "1rem",
                        }}
                    >
                        <Tooltip title="Format the JSON input.">
                            <Box width="fit-content">
                                <StandartButton
                                    iconButton
                                    variant={ButtonVariant.BLACK_OUTLINED}
                                    onClick={() => {
                                        const beautified = beautifyJson(textbox);
                                        setTextbox(beautified);
                                    }}
                                >
                                    <FormatIndentIncreaseIcon />
                                </StandartButton>
                            </Box>
                        </Tooltip>
                    </Box>
                </FormControl>
                {!isValidJson() && textbox && (
                    <FormHelperText style={{ color: "#dc3545" }}>
                        Not valid JSON!
                    </FormHelperText>
                )}
            </Form.Group>
        </Col>
    );
};

export default Json;
